var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legal-texts-show-view"
  }, [_c('link-button', {
    attrs: {
      "icon": "pencil",
      "to": {
        name: 'edit-legal-text',
        params: {
          id: _vm.legalText.id
        }
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('actions.edit')) + "\n  ")]), _vm._v(" "), _c('common-button', {
    attrs: {
      "type": "danger",
      "icon": "trash"
    },
    on: {
      "click": _vm.deleteLegalTextWhenConfirmed
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('actions.delete')) + "\n  ")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('fieldsets.basicFields')))]), _vm._v(" "), _c('attribute-table', {
    attrs: {
      "data": _vm.legalText,
      "fields": ['name', 'insertedAt', 'updatedAt']
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function(name) {
        return [_vm._v("\n      " + _vm._s(name.value) + "\n    ")]
      }
    }, {
      key: "insertedAt",
      fn: function(insertedAt) {
        return [_c('timeago', {
          attrs: {
            "since": insertedAt.value,
            "auto-update": 60
          }
        })]
      }
    }, {
      key: "updatedAt",
      fn: function(updatedAt) {
        return [_c('timeago', {
          attrs: {
            "since": updatedAt.value,
            "auto-update": 60
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('fieldsets.content')))]), _vm._v(" "), _c('div', {
    staticClass: "uk-placeholder uk-background-muted",
    domProps: {
      "innerHTML": _vm._s(_vm.legalText.body)
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e0f6676","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/LegalTexts/ShowView.vue
// module id = 2072
// module chunks = 0